module.exports = __webpack_public_path__ + "static/media/introscr.aecd7ed4.jpg";